export const BRAND_NAME = "Thiruvambady Vadhya Sangam & Kalakshethra";

export const BRAND_NAV = {
  line1: "Thiruvambady",
  line2: "Vadhya Sangam & Kalakshethra",
};

export const CONTACT = {
  email: "vineeshkalyanaraman5@gmail.com",
  formCcEmail: "harishradhakrishnan2001@gmail.com",
  website: "https://thiruvambadyvadhyasangam.com",
  websiteDisplay: "thiruvambadyvadhyasangam.com",
  phone: "+91 6379 135 988",
  phoneTel: "+916379135988",
  phone2: "+91 7010 635 988",
  phone2Tel: "+917010635988",
  phonesDisplay: "+91 6379 135 988 · +91 7010 635 988",
  whatsapp: "https://wa.me/916379135988",
  instagram: "https://www.instagram.com/thiruvambadyvineeshmarar/",
  facebook: "https://www.facebook.com/share/18ie1FQURB/?mibextid=wwXIfr",
  address: {
    line1: "Alappakkam",
    line2: "Chennai, Tamil Nadu 600116",
    full: "Alappakkam, Chennai, Tamil Nadu 600116",
    city: "Chennai",
    area: "Alappakkam",
    postalCode: "600116",
  },
};

/** Web3Forms access key (public by design — tied to CONTACT.email inbox). */
export const WEB3FORMS_ACCESS_KEY =
  process.env.REACT_APP_WEB3FORMS_ACCESS_KEY ||
  "989c1249-5d08-4b9a-8277-4298ad8c0c2b";
